import { NgModule } from "@angular/core";
import { NSAngular } from "../../shared/types";

import { StorageModule } from "../storage/storage.module";
import { FeatureFlagDirective } from "./feature-flags.directive";
import { FlagsRef } from "./flags.service";

export const MODULE_IMPORTS: NSAngular.Import[] = [StorageModule];
export const MODULE_PROVIDERS: NSAngular.Provider[] = [FlagsRef];
export const MODULE_DECLARATIONS: NSAngular.Declaration[] = [FeatureFlagDirective];

@NgModule({
    declarations: MODULE_DECLARATIONS,
    exports: MODULE_DECLARATIONS,
    imports: MODULE_IMPORTS,
    providers: MODULE_PROVIDERS,
})
export class FeatureFlagsModule { }
